<script setup lang="ts">
import { onMounted, ref } from 'vue'

interface Props {
    data: any
}
const props = defineProps<Props>()

onMounted(() => {
    setTimeout(() => {
        new Swiper('.about-team-slider', {
            loop: false,
            slidesPerView: 1 + (1 / window.innerWidth * 32),
            spaceBetween: 8,
            centeredSlides: true,
            navigation: {
                nextEl: '.about-team-slider__next',
                prevEl: '.about-team-slider__prev'
            },
            breakpoints: {
                768: {
                    slidesPerView: 2,
                    spaceBetween: 16,
                    centeredSlides: false
                },
                1200: {
                    slidesPerView: 3,
                    spaceBetween: 16,
                    centeredSlides: false
                }
            }
        })
    }, 1000)
})
</script>

<template>
    <div>
        <section class="about-team">
            <div class="container">
                <div class="about-team__wrapper">
                    <div class="about-team__head">
                        <h2 class="about-team__title"><span class="about-team__title--small">Наша</span> команда</h2>
                        <div class="about-team__toggle">
                            <div class="about-team-slider__prev">
                                <svg xmlns="http://www.w3.org/2000/svg" width="39" height="40" viewBox="0 0 39 40" fill="none">
                                    <rect y="0.652344" width="39" height="39" rx="19.5" fill="white"/>
                                    <path d="M24 11.6523L16 19.6523L24 27.6523" stroke="#7C7C7C"/>
                                </svg>
                            </div>
                            <div class="about-team-slider__next">
                                <svg xmlns="http://www.w3.org/2000/svg" width="39" height="40" viewBox="0 0 39 40" fill="none">
                                    <rect y="0.652344" width="39" height="39" rx="19.5" fill="white"/>
                                    <path d="M16 11.6523L24 19.6523L16 27.6523" stroke="#7C7C7C"/>
                                </svg>
                            </div>
                        </div>
                    </div>
                    <div class="about-team__content">
                        <div class="about-team__slider">
                            <div class="about-team-slider swiper">
                                <div class="about-team-slider__wrapper swiper-wrapper">
                                    <div class="about-team-slider__item swiper-slide" v-for="(item, key) in props.data">
                                        <NuxtLink :to="`/management/${key}`" class="about-team__item">
                                            <div class="about-team__info">
                                                <div class="about-team__name">{{ item.name }}</div>
                                                <div class="about-team__post">{{ item.post }}</div>
                                                <div class="about-team__button btn btn--default">Узнать больше</div>
                                            </div>
                                            <div class="about-team__image">
                                                <NuxtImg
                                                    :src="`/img/management/${key}.jpg`"
                                                    alt=""
                                                    loading="lazy"
                                                    placeholder="/img/loading.gif"
                                                    placeholder-class="loading"
                                                />
                                            </div>
                                        </NuxtLink>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <NuxtLink :to="`/management`" class="about-team__more">
                            <div class="about-team__more-title">Менеджмент компании AKTIVO</div>
                            <div class="about-team__more-button btn btn--default">Посмотреть всех</div>
                        </NuxtLink>
                    </div>
                </div>
            </div>
        </section>
    </div>
</template>

<style lang="scss" scoped>
.about-team {
    $this: &;
    padding-top: 48px;
    background: #E1E5EA;

    &__head {
        display: flex;
        align-items: center;
        justify-content: space-between;
        padding: 0 16px;
        margin-bottom: 16px;
    }

    &__title {
        color:  #162133;
        font-family: 'Muller', sans-serif;
        font-size: 20px;
        font-style: normal;
        font-weight: 700;
        line-height: 120%;
        text-transform: uppercase;

        &--small {
            font-weight: 300;
        }
    }

    &__toggle {
        display: flex;
        align-items: center;
        justify-content: flex-end;
        margin-left: auto;
    }

    &__slider {
        // width: calc(100% + 32px);
        margin: 0 -16px;
    }

    &__item {
        padding: 8px;
        border-radius: 24px;
        background: white;
        backdrop-filter: blur(47px);
        display: flex;
        align-items: flex-start;
        justify-content: space-between;
        text-decoration: none;
    }

    &__info {
        display: flex;
        flex-direction: column;
        align-items: flex-start;
        padding: 8px;
        align-self: stretch;
    }

    &__name {
        color: #162133;
        font-size: 18px;
        font-weight: 600;
        line-height: 125%;
        margin-bottom: 4px;
    }

    &__post {
        color: #162133;
        font-size: 12px;
        font-weight: 500;
        line-height: normal;
        margin-bottom: auto;
        margin-bottom: 8px;
    }

    &__description {
        display: none;
    }

    &__image {
        width: 128px;
        min-width: 128px;
        height: 128px;
        display: flex;
        align-items: center;
        justify-content: center;
        border-radius: 24px;
        overflow: hidden;

        img {
            width: 100%;
            height: 100%;
            object-fit: cover;
            object-position: top;
        }
    }

    &__button {
        margin-top: auto;
    }

    &__more {
        display: none;
    }
}

@media screen and (min-width: 767.98px) {
    .about-team {
        padding-top: 32px;

        &__head {
            padding: 32px 40px;
            margin-bottom: 0;
        }

        &__title {
            font-size: 34px;
            line-height: 120%;
        }

        &__content {
            display: flex;
            align-items: flex-start;
            justify-content: space-between;
        }

        &__slider {
            width: calc(100% - 235px - 16px);
            margin: 0;
        }

        &__item {
            flex-direction: column-reverse;
            justify-content: flex-end;
            padding: 0;
            height: 100%;
            border-radius: 32px;
        }

        &__image {
            width: 100%;
            height: 234px;
        }

        &__info {
            padding: 24px;
            flex: 1;
        }

        &__name {
            font-size: 24px;
            line-height: normal;
            margin-bottom: 8px;
        }

        &__post {
            font-size: 14px;
            line-height: 140%; 
            margin-bottom: 0;
        }

        &__button {
            display: none;
        }

        &__more {
            display: flex;
            flex-direction: column;
            align-items: center;
            justify-content: center;
            padding: 24px;
            border-radius: 32px;
            background: #84929F;
            backdrop-filter: blur(47px);
            align-self: stretch;
            text-decoration: none;
            width: 235px;
        }

        &__more-title {
            color: white;
            font-size: 24px;
            font-style: normal;
            font-weight: 600;
            line-height: normal;
            text-align: center;
            margin-bottom: 32px;
        }
    }
}


@media screen and (min-width: 1199.98px) {
    .about-team {
        padding-top: 56px;

        &__slider {
            width: calc(100% - 280px - 16px);
        }

        &__image {
            height: 280px;
        }

        &__more {
            width: 280px;
        }
    }
}

@media screen and (min-width: 1360px) {
    .about-team {
        &__slider {
            width: calc(100% - 318px - 16px);
        }

        &__image {
            height: 318px;
        }

        &__more {
            width: 318px;
        }
    }
}

.about-team-slider {
    &__item {
        height: auto;
    }
    &__prev, &__next {
        width: 39px;
        height: 39px;
        display: flex;
        align-items: center;
        justify-content: center;
        margin-left: 8px;
        cursor: pointer;

        &.swiper-button-disabled {
            opacity: 0.5;
        }
    }
}

@media screen and (min-width: 1199.98px) {
    .about-team-slider {
        &__prev, &__next {
            margin-left: 16px;
        }
    }
}
</style>